export default __webpack_public_path__ + "static/3.1-856c0ab2385e12c59e982729c6f9a532.webp";